module.exports = __webpack_public_path__ + "static/media/khalid.0bfaa49e.jpg";